import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['select', 'warning'];

  static values = { saved: String };

  connect() {
    this.refresh();
  }

  refresh() {
    this.warningTarget.classList.toggle('hidden', this.selectTarget.value === this.savedValue);
  }
}
